import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSeo } from 'useSeo';

export default function CustomeHelmet({pageName}) {
  const { title, description, ogTitle, keywords, ogImage } = useSeo({ pageName: pageName });

  return (
    <>
        <Helmet>
        <meta name="robots" content="index, follow" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:site_name" content={title} />
        <meta name="author" content={title} />
      </Helmet>
    </>
  );
}
